import { TuiButtonModule, TuiScrollbarModule } from '@taiga-ui/core';
import { TranslateModule } from '@ngx-translate/core';
import { Store } from '@ngrx/store';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Component, DestroyRef, inject } from '@angular/core';
import { HttpResponse } from '@angular/common/http';

import { ConsentTextComponent } from './consent-text';
import { ConsentApprovalApiService } from './consent-approval-api.service';

import { authActions } from '@iss/wo-common/ngrx';
import { ContentPanelComponent } from '@iss/core/content-panel';

@Component({
  templateUrl: './consent-approval.component.html',
  styleUrls: [ './consent-approval.component.scss' ],
  standalone: true,
  imports: [
    ConsentTextComponent,
    TranslateModule,
    TuiScrollbarModule,
    TuiButtonModule,
    ContentPanelComponent,
  ],
})
export class ConsentApprovalComponent {
  private readonly destroyRef = inject(DestroyRef);
  private readonly consentApprovalApiService = inject(ConsentApprovalApiService);
  private readonly store = inject(Store);
  public requestPending = false;

  public sendConsentApproval(): void {
    this.requestPending = true;
    this.consentApprovalApiService.sendConsent()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(res => this.handleResponse(res));
  }

  private handleResponse(response: HttpResponse<string>): void {
    this.requestPending = false;
    if (response.ok) {
      location.reload();
    }
  }

  public onRejectSelected(): void {
    this.store.dispatch(authActions.logout({ withRequest: true }));
  }
}
